import { useAuth } from '@features/auth/hooks/useAuth';
import { PlayerEloStatPreviewWidget } from '@features/user/ui/PlayerEloStatsPreview/PlayerEloStatPreview/PlayerEloStatPreviewWidget';
import { PlayerEloStatsPreview } from '@features/user/ui/PlayerEloStatsPreview/PlayerEloStatsPreview';

type Props = {
  setIsModalOpen: (newValue: boolean) => void;
};
export function PlayerEloStatsPreviewWidget({ setIsModalOpen }: Props) {
  const { user } = useAuth();

  return (
    <PlayerEloStatsPreview setIsModalOpen={setIsModalOpen}>
      <PlayerEloStatPreviewWidget clockControlType="Bullet" userId={user?.userId} />
      <PlayerEloStatPreviewWidget clockControlType="Blitz" userId={user?.userId} />
      <PlayerEloStatPreviewWidget clockControlType="Rapid" userId={user?.userId} />
    </PlayerEloStatsPreview>
  );
}
